import ValueX from '../types/ValueX';

export default class OnsetX extends ValueX {
    static __className = 'OnsetX';

    constructor(constructJson) {
        super(constructJson, 'onset', 'OnsetX');
    }
}
